"use client";

import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-light-background py-16 md:py-24">
      <div className={`container mx-auto px-4 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-light">
              Ready to Experience Expert HVAC Service?
            </h2>
            <p className="text-foreground-light/80 text-lg">
              Contact us today for reliable heating and cooling solutions
            </p>
          </div>

          <div className="flex flex-col items-center gap-6">
            <Link to="tel:+14125557890" className="group inline-flex items-center gap-3 text-foreground-light transition-all duration-[120ms] ease-in-out hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md px-2 py-1">
              <Phone className="size-6 text-primary" />
              <span className="font-display text-3xl md:text-4xl font-bold tracking-wide relative">(412) 980-0953<span className="absolute bottom-0 left-0 w-full h-[2px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-[250ms] ease-smooth origin-left" data-ast-id="f:/src/pages/Commercial/sections/ContactCta.tsx|sig:t828i0" data-ast-start="1674" data-ast-end="1841"></span></span>
            </Link>

            <Button size="lg" className="text-base font-semibold px-8 py-6 h-auto transition-all duration-[120ms] ease-in-out hover:-translate-y-[2px] hover:shadow-medium active:translate-y-0">
              Request Service
            </Button>
          </div>
        </div>
      </div>
    </section>;
}